/* libs */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { asField } from "informed";
import ValidateItem from "../../../helpers/validation/validateInput";
import validatehoc from "../Validator";

class TextAndValueArray extends Component {
	constructor(props) {
		super(props);

		this.state = {
			minimizePlaceholder: false,
			focusOnLastItem: false,
		};
	}

	validate = value => {
		const { placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage } = this.props;
		return ValidateItem(value, placeholder, isRequired, validationRegex, minLength, maxLength, regexMessage);
	};

	updateItemText = (key, event) => {
		const { fieldState } = this.props;
		const value = fieldState.value || [];
		let newValue = value.concat();
		if (!newValue[key]) {
			newValue[key] = {};
		}
		newValue[key].text = event.target.value;
		this.updateValue(newValue);
		if (key === value.length) {
			this.focusOnLastItem();
		}
	};
	updateItemValue = (key, event) => {
		const { fieldState } = this.props;
		const value = fieldState.value || [];
		let newValue = value.concat();
		newValue[key].value = event.target.value;
		this.updateValue(newValue);
		if (key === value.length) {
			this.focusOnLastItem();
		}
	};

	removeIndex = key => {
		const { fieldState } = this.props;
		const value = fieldState.value || [];
		let newValue = value.concat();
		newValue.splice(key, 1);
		this.updateValue(newValue);
	};

	updateValue = newValue => {
		this.props.fieldApi.setValue(newValue);
		this.props.fieldApi.setTouched(true);
	};

	focusOnLastItem = () => {
		this.setState({ focusOnLastItem: true });
	};

	removeForceFocus = () => {
		this.setState({ focusOnLastItem: false });
		return true;
	};
	onFocus = event => {
		this.setState({
			minimizePlaceholder: true,
		});
		if (this.state.focusOnLastItem) {
			this.removeForceFocus();
			let value = event.target.value; // This looks weird, however it's used to move the cursor to the end to continue typing
			event.target.value = "";
			event.target.value = value;
		}
	};

	onBlur = () => {
		this.setState({
			minimizePlaceholder: false,
		});
	};

	render() {
		const { fieldState, placeholder, helperText, isRequired } = this.props;
		const { error } = fieldState;
		const value = fieldState.value || [];
		const shouldFocus = (value && value.length > 0) || this.state.minimizePlaceholder;
		const isFocused = shouldFocus ? " focus" : "";
		const hasError = error ? " has-error" : "";
		let items = [];
		if (value && value.length > 0) {
			value.forEach((item, key) => {
				items.push(
					<div className="text-array-item relative" key={key}>
						<div className="value-array-row">
							<div className="value-array-container">
								<input
									value={item.text}
									className="text-array-text"
									onChange={event => {
										this.updateItemText(key, event);
									}}
									onBlur={event => {
										this.updateItemText(key, event);
									}}
									autoFocus={key === value.length - 1 && this.state.focusOnLastItem}
									onFocus={event => this.onFocus(event)}
								/>
							</div>
							<div className="value-array-container">
								<input
									value={item.value}
									className="text-array-value"
									onChange={event => {
										this.updateItemValue(key, event);
									}}
									onBlur={event => {
										this.updateItemValue(key, event);
									}}
									onFocus={event => this.onFocus(event)}
								/>
								<div className="remove-icon" title="Remove" onClick={() => this.removeIndex(key)}>
									<i className="fal fa-times-circle icon"></i>
								</div>
							</div>
						</div>
					</div>
				);
			});
		}
		return (
			<div className={`text-array-input${hasError}`}>
				<div className={`text-array-wrap${isFocused}${hasError}`}>
					<div className="placeholder">
						<span className={shouldFocus ? "caption-text" : ""}>
							{isRequired && <span className="isrequired-label">*</span>}
							{placeholder}
						</span>
					</div>
					<div className="text-array-border">
						<div className="text-array-items">{items}</div>
						<div className="new-item">
							<input
								value={""}
								placeholder="+"
								onChange={event => {
									this.updateItemText(value.length, event);
								}}
								onFocus={() => {
									this.onFocus();
								}}
								onBlur={() => this.onBlur()}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-6">
						<div className="caption-text helper-message">{helperText}</div>
					</div>
					<div className="col-xs-6">
						<div className="error-message caption-text">{error ? error : ""}</div>
					</div>
				</div>
			</div>
		);
	}
}

TextAndValueArray.propTypes = {
	field: PropTypes.string,
	helperText: PropTypes.string,
	id: PropTypes.string,
	placeholder: PropTypes.string,
	autocomplete: PropTypes.string,
	isRequired: PropTypes.bool,
	minLength: PropTypes.number,
	maxLength: PropTypes.number,
	validationRegex: PropTypes.string,
	regexMessage: PropTypes.string,
	type: PropTypes.string,
	themeId: PropTypes.string,
	fieldState: PropTypes.object,
};

const Wrapper = validatehoc(
	asField(({ fieldState, ...props }) => <TextAndValueArray fieldState={fieldState} {...props} />),
	"textAndValueArray"
);

export default Wrapper;
